import React from 'react';

const Terms = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-content">
          <h1>
            <i className="fas fa-file-contract"></i>
            Politique de confidentialite
          </h1>
          <p className="last-updated">Dernière mise à jour: Juin 8, 2025</p>

          <section>
            <h2>Confidentialité & Données Personnelles</h2>
            <p>
              Les informations recueillies sur le site : b-para font l'objet d'un traitement destiné notamment à la commande d'un produit, le paiement et la livraison. Les destinataires des données se limitent exclusivement aux personnes habilitées à connaître vos données en raison de leurs fonctions. Conformément à la loi n° 09-08 promulguée par le dahir 1.09.15 du 18 février 2009, relative à la protection des personnes physiques à l'égard du traitement des données à caractère personnel, vous bénéficiez d'un droit d'accès et de rectification aux informations qui vous concernent, que vous pouvez exercer en vous adressant à notre service client:+212 606-271464
            </p>
          </section>

          <section>
            <h2>Modification :</h2>
            <p>
              cette politique de confidentialité peut changer à tout moment par exemple en incluant ou excluant des clauses.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;